var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FeedModeTabs"},[_c('Tabs',{attrs:{"tabs":_vm.tabs},on:{"tab":function (tab) {
        _vm.setQuery({ availableFor: tab.id });
        _vm.updateFeed();
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }